import React, { createContext, useContext, useState, useEffect } from "react";
import serviceQuery from "../requests/ServiceQuery";
import { ECLLoader } from "../../eclComponents/";
import { AuthContext } from "./AuthContext";
import { ToastContext } from "./ToastContext";
import { translate } from "../Translate";

export const UserPreferencesContext = createContext();

export function UserPreferencesContextProvider(props) {
   const auth = useContext(AuthContext);
   const addToast = useContext(ToastContext);

   const [preferences, setPreferences] = useState({
      theme: localStorage.getItem("userTheme") === "Dark" ? "Dark" : "Light",
      themeToggle: () => {
         localStorage.getItem("userTheme") === "Dark"
            ? toggleThemePreferences("Dark")
            : toggleThemePreferences("Light");
      },
   });

   function toggleThemePreferences(theme) {
      document
         .getElementById("thematic-div")
         .setAttribute("data-theme", theme === "Dark" ? "Dark" : "Light");
      localStorage.setItem("userTheme", theme === "Dark" ? "Dark" : "Light");
      setPreferences({
         theme: theme === "Dark" ? "Dark" : "Light",
         themeToggle: () => {
            theme === "Dark"
               ? toggleThemePreferences("Light")
               : toggleThemePreferences("Dark");
         },
      });
      serviceQuery({
         message: "SingleUserSavePreferenceMessage",
         query: {
            userId: auth.credentials.userID,
            key: "user_theme_json_save_key",
            timestamp: Math.round(Date.now() / 1000),
            userData: theme === "Dark" ? "Dark" : "Light",
         },
      })
         .then(() => {
            addToast(translate("Preferences saved"));
         })
         .catch((error) => {
            console.error(error);
            addToast(translate("Error Fetching Preferences"));
            auth.logout();
         });
   }

   //Get the initial state of preferences (theme)
   useEffect(() => {
      serviceQuery({
         message: "SingleUserPreferenceGetMessage",
         query: {
            userId: auth.credentials.userID,
            key: "user_theme_json_save_key",
         },
      })
         .then((res) => {
            const acceptableStates = ["Dark", "Light", ""];
            let preference;
            if (acceptableStates.includes(res.Payload.preferences)) {
               preference = res.Payload.preferences;
            } else {
               preference = atob(res.Payload.preferences).replaceAll('"', "");
            }
            document
               .getElementById("thematic-div")
               .setAttribute(
                  "data-theme",
                  preference === "Dark" ? "Dark" : "Light",
               );
            localStorage.setItem(
               "userTheme",
               preference === "Dark" ? "Dark" : "Light",
            );
            setPreferences({
               theme: preference === "Dark" ? "Dark" : "Light",
               themeToggle: () => {
                  preference === "Dark"
                     ? toggleThemePreferences("Light")
                     : toggleThemePreferences("Dark");
               },
            });
         })
         .catch((error) => {
            console.error(error);
            addToast(translate("Error Fetching Preferences"));
            auth.logout();
         });
   }, []);

   if (!preferences) {
      return <ECLLoader />;
   }
   return (
      <UserPreferencesContext.Provider value={preferences}>
         {props.children}
      </UserPreferencesContext.Provider>
   );
}
